import { render, staticRenderFns } from "./FillOutStuInfo.vue?vue&type=template&id=401cbae1&scoped=true"
import script from "./FillOutStuInfo.vue?vue&type=script&lang=js"
export * from "./FillOutStuInfo.vue?vue&type=script&lang=js"
import style0 from "./FillOutStuInfo.vue?vue&type=style&index=0&id=401cbae1&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401cbae1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('401cbae1')) {
      api.createRecord('401cbae1', component.options)
    } else {
      api.reload('401cbae1', component.options)
    }
    module.hot.accept("./FillOutStuInfo.vue?vue&type=template&id=401cbae1&scoped=true", function () {
      api.rerender('401cbae1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/StudentAnswer/components/FillOutStuInfo.vue"
export default component.exports